module.exports = "<svg viewBox=\"0 0 12.6 15.1\" height=\"15.1px\" width=\"12.6px\">\n<rect class=\"control-svg\" x=\"7.8\" y=\"0\" fill=\"#000111\" width=\"4.8\" height=\"15.1\"/>\n<rect class=\"control-svg\" x=\"0\" y=\"0\" fill=\"#000111\" width=\"4.8\" height=\"15.1\"/>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/pause.svg
// module id = 345
// module chunks = 0